// Video library, tagged all the way down to a Sub-Topic (see
// assessmentHierarchyData.js). Backed by localStorage — see
// assessmentLocalStore.js for how this swaps to a real API later.
import { createStore, slugify } from "./assessmentLocalStore";

const KEY = "assessmentVideoLibrary";

export const VIDEO_TYPES = ["Concept", "Chapter", "Solution", "Revision"];
export const VIDEO_STATUSES = ["PUBLISHED", "DRAFT"];

// Resolve a stored path/URL to an absolute media URL — mirrors the helper
// already used for playback elsewhere in the admin (MentorDocumentsUploads.jsx).
export const resolveMediaUrl = (path) =>
  !path ? "" : /^https?:\/\//.test(path) ? path : `https://siaedutech.com/public/${path}`;

const SAMPLE_VIDEO_BASE = "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/";

const DEFAULT_VIDEOS = [
  { id: "inertia-and-mass-concept", title: "Inertia and Mass Explained", subTopicId: "inertia-and-mass", type: "Concept", duration: "18:04", status: "PUBLISHED", videoUrl: `${SAMPLE_VIDEO_BASE}ForBiggerFun.mp4` },
  { id: "f-equals-ma-derivation", title: "F = ma Derivation", subTopicId: "f-equals-ma", type: "Concept", duration: "22:11", status: "PUBLISHED", videoUrl: `${SAMPLE_VIDEO_BASE}ForBiggerJoyrides.mp4` },
  { id: "momentum-impulse-solution", title: "Momentum & Impulse — Solved Problems", subTopicId: "momentum-and-impulse", type: "Solution", duration: "31:27", status: "PUBLISHED", videoUrl: `${SAMPLE_VIDEO_BASE}ForBiggerMeltdowns.mp4` },
  { id: "friction-recap", title: "Static vs Kinetic Friction Recap", subTopicId: "static-vs-kinetic-friction", type: "Revision", duration: "12:30", status: "DRAFT", videoUrl: `${SAMPLE_VIDEO_BASE}ForBiggerBlazes.mp4` },
  { id: "conservation-of-energy-lecture", title: "Conservation of Energy Lecture", subTopicId: "law-of-conservation", type: "Chapter", duration: "42:18", status: "PUBLISHED", videoUrl: `${SAMPLE_VIDEO_BASE}BigBuckBunny.mp4` },
  { id: "ionic-bonding-lattice", title: "Lattice Energy Walkthrough", subTopicId: "ionic-lattice-energy", type: "Concept", duration: "28:45", status: "PUBLISHED", videoUrl: `${SAMPLE_VIDEO_BASE}ElephantsDream.mp4` },
  { id: "journal-entries-solution", title: "Compound Journal Entries Solved", subTopicId: "compound-journal-entries", type: "Solution", duration: "35:52", status: "DRAFT", videoUrl: `${SAMPLE_VIDEO_BASE}ForBiggerEscapes.mp4` },
];

const store = createStore(KEY, DEFAULT_VIDEOS);

export const getVideos = store.getAll;
export const getVideoById = store.getById;
export const saveVideo = store.save;
export const deleteVideo = store.remove;

// Called by hierarchy cascade deletes (a Subject/Chapter/Topic going away
// takes its Sub-Topics with it) so Videos never end up pointing at a
// Sub-Topic that no longer exists.
export async function deleteVideosBySubTopicIds(subTopicIds) {
  if (!subTopicIds?.length) return [];
  const idSet = new Set(subTopicIds);
  return store.removeWhere((v) => idSet.has(v.subTopicId));
}

export { slugify };
